import React from 'react';

import { Calendar } from 'primereact/calendar';

import Locale from './Locale';

const Datepicker: React.FC<
  React.ComponentProps<typeof Calendar> & {
    id?: string;
    className?: string;
    dateFormat?: string;
  }
> = (props) => {
  return (
    <Calendar
      {...props}
      className={`${props.className || ''}`}
      id={props.id}
      inputId={props.id + 'Input'}
      locale={Locale}
      dateFormat={props.dateFormat || 'dd-mm-yy'}
    />
  );
};

export default Datepicker;
